import { type ChangeEvent, useEffect, useState } from "react";
import styles from "./styles.module.css";

type PlayerSearchFormProps = {
  onSubmit: (value: string) => void;
  disabled: boolean;
  highlight: boolean;
  onHighlightInput: () => void;
  initialValue?: string;
};

export default function PlayerSearchForm({
  onSubmit,
  disabled,
  highlight,
  onHighlightInput,
  initialValue,
}: PlayerSearchFormProps) {
  const [value, setValue] = useState(initialValue ?? "");
  const [didPrefill, setDidPrefill] = useState(false);
  const [hasUserInput, setHasUserInput] = useState(false);

  useEffect(() => {
    if (!initialValue) return;
    if (didPrefill || hasUserInput || value !== "") return;
    setValue(initialValue);
    setDidPrefill(true);
  }, [initialValue, didPrefill, hasUserInput, value]);

  const classes = [styles.form, ...(highlight ? [styles.highlight] : [])].join(" ");
  const showPrefillHint = Boolean(initialValue) && !hasUserInput;

  function onInputChange(e: ChangeEvent<HTMLInputElement>) {
    if (highlight) onHighlightInput();

    const numeric = e.target.value.replace(/\D/g, "");
    setHasUserInput(true);
    setValue(numeric);
  }

  return (
    <div className={styles.container}>
      {showPrefillHint && <div className={styles.prefillHint}>ID подставлен</div>}
      <div style={{ display: "flex", gap: "10px" }} className={classes}>
        <input
          style={{ borderRadius: "9px" }}
          type="text"
          inputMode="numeric"
          placeholder="ID игрока (только цифры)"
          value={value}
          onChange={onInputChange}
          onKeyDown={(e) => e.key === "Enter" && onSubmit(value)}
          disabled={disabled}
        />

        <button
          style={{ borderRadius: "9px", background: "linear-gradient(180deg, #008033 0%, #006428 100%)" }}
          onClick={() => onSubmit(value)}
          disabled={disabled || !value}
        >
          Найти
        </button>
      </div>
    </div>
  );
}
